import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { observer } from 'mobx-react-lite';
import { Context } from '../../index';
import {FaTimes} from "react-icons/fa";
import {FaCheck, FaPersonRunning} from "react-icons/fa6";

const AllUserPollItems = observer(({onPoolItemSelect, setActiveComponent}) => {
    const { poolStore } = useContext(Context);


    const handleRowClick = (pollItem) => {
        poolStore.setSelectedPoolItem(pollItem);
        onPoolItemSelect(pollItem);
        setActiveComponent('PollItemFull');
    };


    return (
        <div className="card text-start align-content-center shadow-sm mt-2 mb-0 p-3" style={{ width: '100%' }}>
            <div className="mt-0">
                <h6 className="text-muted fst-italic">All Polls You're Taking</h6>

                {/* 📱 Адаптивная обёртка */}
                <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '8px' }}>
                    <Table
                        striped
                        bordered
                        hover
                        size="sm"
                        className="shadow-sm rounded small mb-0"
                        style={{ minWidth: '950px' }} // фикс для скролла
                    >
                        <thead className="table-light small text-muted">
                        <tr>
                            <th className="text-center fst-italic">#</th>
                            <th className="text-start fst-italic">Poll Name</th>
                            <th className="text-center fst-italic">Poll Type</th>
                            <th className="text-center fst-italic">Language</th>
                            <th className="text-center fst-italic">You Start</th>
                            <th className="text-center fst-italic">Option Count</th>
                            <th className="text-center fst-italic">Status</th>
                            <th className="text-center fst-italic">Completed Date</th>
                            <th className="text-center fst-italic">Winner Option</th>
                        </tr>
                        </thead>
                        <tbody>
                        {poolStore?.currentUserPoolItems?.map((poll, index) => (
                            <tr
                                className="small"
                                key={poll.id}
                                onClick={() => handleRowClick(poll)}
                                style={{ cursor: 'pointer' }}
                            >
                                <td className="text-center fst-italic">{index + 1}</td>
                                <td className="text-start">
                                    {{
                                        'COVER_POLL': 'Cover Poll',
                                        'TITLE_POLL': 'Title Poll',
                                        'COVER_TITLE_POLL': 'Cover & Title Poll',
                                        'DESCRIPTION_POLL': 'Description Poll',
                                        'MIXED_POLL': 'Mixed Poll'
                                    }[poll?.pool?.pool_type] || 'Unknown'} #{poll?.pool?.id}-{poll?.id} created in {new Date(poll?.pool?.createdAt).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: false,
                                })}
                                </td>
                                <td className="text-center fst-italic">
                                    {{
                                        'COVER_POLL': 'Cover Poll',
                                        'TITLE_POLL': 'Title Poll',
                                        'COVER_TITLE_POLL': 'Cover & Title Poll',
                                        'DESCRIPTION_POLL': 'Description Poll',
                                        'MIXED_POLL': 'Mixed Poll'
                                    }[poll?.pool?.pool_type] || 'Unknown'}
                                </td>
                                <td className="text-center fst-italic">{poll?.pool?.language}</td>
                                <td className="text-center fst-italic">
                                    {new Date(poll?.start_date * 60000).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                    })}
                                </td>
                                <td className="text-center fst-italic">
                                    {
                                        Array.from({ length: 8 }).filter((_, i) =>
                                            poll?.pool?.[`pool_item${i + 1}_flag`]
                                        ).length || 0
                                    }
                                </td>
                                <td className="text-center fst-italic">
                                    {{
                                        'STEP1': <FaPersonRunning className="text-success" />,
                                        'STEP2': <FaCheck className="text-success" />
                                    }[poll?.respondent_step] || 'N/A'}
                                </td>
                                <td className="text-center fst-italic">
                                    {poll?.end_date ? (
                                        new Date(poll.end_date * 60000).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false,
                                        })
                                    ) : (
                                        <FaTimes className="text-success" />
                                    )}
                                </td>
                                <td className="text-center fst-italic">
                                    {poll?.winner ? `Option #${poll.winner}` : <FaTimes className="text-success" />}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );

});

export default AllUserPollItems;